
import React, {useState} from 'react';
import ClientSpace from "./Components/client_space";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Landingpage from './Components/landingPage';



const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Landingpage/>,
    },

    {
      path: "/client",
      element: <ClientSpace />,
    },


   
  
  ]);


  return(
<React.StrictMode >
    <RouterProvider router={router} />
  

    </React.StrictMode>
  
  );

}

export default App;
